import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { type ReactNode } from 'react'

import { isApproverNotOnWorkflowError } from '@/utils/approverNotOnWorkflow'
import { isSCACancelledError } from '@/utils/scaErrors'

// Create a query client with defaults. Note individual queries can override these defaults.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh for 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: (failureCount, error) => {
        if (isSCACancelledError(error) || isApproverNotOnWorkflowError(error)) {
          return false
        }

        return failureCount < 1
      },
      refetchOnWindowFocus: false, // Avoid unnecessary refetches
    },
  },
})

export function QueryProvider({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default QueryProvider
